import client from './client';

export const vmHostsApi = {
  async list(params = {}) {
    const { data } = await client.get('/api/vm/hosts', { params });
    return data;
  },

  async get(id) {
    const { data } = await client.get(`/api/vm/hosts/${id}`);
    return data;
  },

  async create(payload) {
    const { data } = await client.post('/api/vm/hosts', payload);
    return data;
  },

  async update(id, updates) {
    const { data } = await client.patch(`/api/vm/hosts/${id}`, updates);
    return data;
  },

  async delete(id) {
    const { data } = await client.delete(`/api/vm/hosts/${id}`);
    return data;
  },

  async rotateKey(id) {
    const { data } = await client.post(`/api/vm/hosts/${id}/rotate-key`);
    return data;
  },

  async services(id) {
    const { data } = await client.get(`/api/vm/hosts/${id}/services`);
    return data;
  },

  async containers(id) {
    const { data } = await client.get(`/api/vm/hosts/${id}/containers`);
    return data;
  },

  async packages(id, { includeRemoved = false } = {}) {
    const { data } = await client.get(`/api/vm/hosts/${id}/packages`, {
      params: includeRemoved ? { includeRemoved: 'true' } : {},
    });
    return data;
  },

  async configs(id) {
    const { data } = await client.get(`/api/vm/hosts/${id}/configs`);
    return data;
  },

  async configDetail(id, configId) {
    const { data } = await client.get(`/api/vm/hosts/${id}/configs/${configId}`);
    return data;
  },
};
